import styles from "./month-range-picker.module.scss";
import type { MonthView } from "./types-month-range-picker";

export function MonthRangePickerMonth({
  label,
  ariaLabel,
  state,
  pressed,
  disabled,
  testId,
  onPick,
  onHover,
}: MonthView) {
  return (
    <button
      type="button"
      className={styles.month}
      data-state={state}
      aria-pressed={pressed}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onPick}
      onMouseEnter={onHover}
      data-testid={testId}
    >
      {label}
    </button>
  );
}
